<template>
  <div class="plan-page">
    <Row>
      <Col span="13" style="padding: 0 5px;">
        <!-- <Button class="plan-btn" type="ghost" @click="planClick">{{$t('plan.Production.list')}}</Button> -->
        <Row>
          <i-Col span="5">
            <Input class="search" v-model="search1" :placeholder="$t('plan.Production.collectorName')"></Input>
          </i-Col>
          <i-Col span="8">
            <Input class="search" v-model="search2" :placeholder="$t('plan.Production.orderNo')">
              <Button slot="append" icon="ios-search" @click="planSearch()"></Button>
              <Button slot="append" icon="refresh" @click="planReset()"></Button>
            </Input>
          </i-Col>
          <!-- <i-Col span="8">
            <Input class="search" v-model="search3" :placeholder="$t('Order.customer')"></Input>
          </i-Col> -->
        </Row>
        <Table size="small" class="collector-table" highlight-row stripe border :columns="planColumns" :data="planDatas"></Table>
      </Col>
      <Col span="11" style="padding: 0 5px;">
      <Row>
        <Col span="8">
          <Form class="edit-form" :label-width="80">
            <FormItem :label="$t('plan.Production.orderNo')">
              <Input v-model="currentOrder.orderNo" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
            <FormItem :label="$t('plan.Production.num')">
              <Input v-model="currentOrder.num" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
          </Form>
        </Col>
        <Col span="8">
          <Form class="edit-form" :label-width="80">
            <FormItem :label="$t('plan.Production.productNo')">
              <Input v-model="currentOrder.productNo" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
            <FormItem :label="$t('plan.Production.deliveryTime')">
              <Input v-model="currentOrder.deliveryTime" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
          </Form>
        </Col>
        <Col span="8">
          <Form class="edit-form" :label-width="80">
            <FormItem :label="$t('plan.Production.productName')">
              <Input v-model="currentOrder.name" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
            <FormItem :label="$t('plan.Production.name')">
              <Input v-model="currentCollector.name" :placeholder="$t('plan.Production.please_enter')" disabled></Input>
            </FormItem>
          </Form>
        </Col>
      </Row>
        <Tabs class="custom-tabs" :value="Steps" @on-click="TabRest">
            <TabPane :label="$t('plan.Production.chooose_order')" name="1">
              <!-- <p class="title">{{$t('plan.Production.chooose_order')}}</p> -->
              <Row class="search-area">
                <i-Col span="6">
                  <Select v-model="Valid" :value="Valid">
                    <Option value="1" key= 1>{{$t('plan.Production.No_scheduling')}}</Option>
                    <Option value="2" key= 2>{{$t('plan.Production.Not_production')}}</Option>
                    <Option value="3" key= 3>{{$t('plan.Production.Producting')}}</Option>
                  </Select>
                </i-Col>
                <i-Col span="14">
                    <Input v-model="searchOrder" :placeholder="$t('plan.Production.orderNo')">
                       <Button slot="append" icon="ios-search" @click="handleSearch(1)"></Button>
                       <Button slot="append" icon="refresh" @click="handleReset(1)"></Button>
                    </Input>
                </i-Col>
              </Row>
              <Card class="order-card" v-for="order in orderDatas" :key="order.orderID">
                <p slot="title">
                  <Row>
                    <Col span="15">{{$t('plan.Production.orderNo')}}: {{order.orderNo}}</Col>
                  </Row>
                </p>
                <Table size="small" :show-header="showheader" class="order-table" stripe border :columns="orderColumns" :data="order.orderProducts" @on-row-click="orderSelect"></Table>
              </Card>
            </TabPane>
            <TabPane :label="$t('plan.Production.choose_device')" name="2" disabled>
              <!-- <p class="title">{{$t('plan.Production.choose_device')}}</p> -->
              <Row class="search-area">
                  <Input type="text" v-model="searchCollector" :placeholder="$t('plan.Production.searchCollector')">
                    <Button slot="append" icon="ios-search" @click="handleSearch(2)"></Button>
                     <Button slot="append" icon="refresh" @click="handleReset(2)"></Button>
                  </Input>
              </Row>
              <Table size="small" class="collector-table" highlight-row stripe border :columns="collectorColumns" :data="collectorDatas" @on-row-click="collectorSelect"></Table>
            </TabPane>
            <TabPane :label="$t('plan.Production.choose_plan')" name="3" disabled>
              <Form class="edit-form" :label-width="100">

                <FormItem>
                  <RadioGroup v-model="Radioselection" type="button" @on-change="ProductionSelect">
                     <Radio :label="1">{{$t('plan.Production.save1')}}</Radio>
                     <Radio :label="2">{{$t('plan.Production.save2')}}</Radio>
                     <Radio :label="3">{{$t('plan.Production.save3')}}</Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem :label="$t('plan.Production.planIndex')">
                  <Select class="info" v-model="planIndex" :value="planIndex" v-if="Radioselection === 1" disabled >
                  </Select>
                  <Select class="info" v-model="planIndex" :value="planIndex" v-if="Radioselection === 2 && check === true" >
                    <Option v-for="i in [2,3,4,5,6]" :value="i" :key="i">{{ i }}</Option>
                  </Select>
                  <Select class="info" v-model="planIndex" :value="planIndex" v-if="(Radioselection === 2 && check === false) || Radioselection === 3" >
                    <Option v-for="i in [1,2,3,4,5,6]" :value="i" :key="i">{{ i }}</Option>
                  </Select>
                  <Select class="info" v-model="planIndex" :value="planIndex" v-if="Radioselection === 0" ></Select>
                </FormItem>
                <FormItem :label="$t('plan.Production.row')">
                  <Select class="info" v-model="row" :placeholder="$t('plan.Production.please_enter')">
                    <Option v-for="i in restRow" :value="i" :key="i">{{ i }}</Option>
                  </Select>
                </FormItem>
              </Form>
              <hr>
              <Button type="success" v-if="permissions !== true" @click="save()" disabled>{{$t('plan.Production.save')}}</Button>
              <Button type="success" v-if="permissions === true && Radioselection === 1" @click="save(1)">{{$t('plan.Production.save')}}</Button>
              <Button type="success" v-if="permissions === true && Radioselection === 2" @click="save(2)">{{$t('plan.Production.save')}}</Button>
              <Button type="success" v-if="permissions === true && Radioselection === 3" @click="save(3)">{{$t('plan.Production.save')}}</Button>

            </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Product',
  data () {
    return {
      showheader: false,
      searchOrder: '',
      searchCollector: '',
      // countrow: '',
      Radioselection: 0,
      orderColumns: [
        {
          title: this.$t('plan.Production.status'),
          key: 'status1',
          width: 100,
          render: (h, params) => {
            if (params.row.valid === 0) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.change(params.row.id)
                  }
                }
              }, params.row.status2)
            } else if (params.row.PPValid === 1 && params.row.CPValid === 1) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'OrderPlan'})
                  }
                }
              }, params.row.status2)
            } else if (params.row.PPValid === 1) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'CollectorPlan'})
                  }
                }
              }, params.row.status2)
            } else {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'ProductionPlan'})
                  }
                }
              }, params.row.status2)
            }
          }
        },
        { title: this.$t('plan.Production.productNo'), key: 'productNo' },
        { title: this.$t('plan.Production.productNo'), key: 'name' },
        { title: this.$t('plan.Production.num'), key: 'num' },
        { title: this.$t('plan.Production.num'), key: 'deliveryTime', width: 99 }
      ],
      collectorColumns: [
        { title: this.$t('plan.Production.name'), key: 'name', sortable: true, sortType: 'asc' },
        { title: this.$t('plan.Production.count'), key: 'count' },
        { title: this.$t('plan.Production.width'), key: 'width' }
      ],
      planColumns: [
        { title: this.$t('plan.Production.collectorName'), key: 'collectorName', sortable: true, sortType: 'asc' },
        { title: this.$t('plan.Production.orderNo'), key: 'orderNo', sortable: true },
        { title: this.$t('plan.Production.productNo'), key: 'productNo', sortable: true },
        { title: this.$t('plan.Production.productName'), key: 'productName', sortable: true },
        { title: this.$t('plan.Production.planIndex'), key: 'planIndex', width: 71, sortable: true },
        { title: this.$t('plan.Production.row'), key: 'row', width: 71 },
        {
          title: this.$t('plan.Production.action'),
          key: 'action',
          width: 94,
          render: (h, params) => {
            if (this.permissions === false) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('plan.Production.delete'))
              ])
            } else if (this.permissions === true && params.row.CPValid === 1) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.productionStop(params.index, params.row.id)
                    }
                  }
                }, this.$t('plan.Production.no'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.remove(params.index)
                    }
                  }
                }, this.$t('plan.Production.delete'))
              ])
            }
          }
        }
      ],
      orderDatas: [],
      collectorDatas: [],
      planDatas: [],
      currentOrder: {},
      currentCollector: {},
      row: 0,
      check: false,
      Valid: '',
      Steps: '1',
      search1: '',
      search2: '',
      search3: '',
      temp1: [],
      planIndex: 1,
      totalPlanDatas: [],
      totalCollectorDatas: [],
      totalOrderDatas: [],
      permissions: false
    }
  },
  computed: {
    restRow () {
      let c = this.currentCollector.count
      // console.log(this.Radioselection)
      if (this.Radioselection === 3) {
        for (let i = 0; i < this.planDatas.length; i++) {
          let p = this.planDatas[i]
          if (p.collectorID === this.currentCollector.id && this.planIndex === p.planIndex) {
            // console.log(this.Radioselection, this.planIndex)
            if (this.Radioselection === 2 && this.planIndex === 1) {
            } else {
              c -= p.row
            }
          }
        }
      }
      return c
    }
  },
  methods: {
    save (tp) {
      if (this.Radioselection === 1) {
        for (let i = 0; i < this.planDatas.length; i++) {
          let p = this.planDatas[i]
          if (p.collectorID === this.currentCollector.id && p.planIndex > this.planIndex) {
            this.planIndex = p.planIndex
          }
        }
        this.planIndex++
      }
      if (Number(this.row) > 0) {
        let plan = {
          collectorID: this.currentCollector.id,
          orderProductID: this.currentOrder.id,
          row: Number(this.row),
          planIndex: this.planIndex,
          tp: tp
        }
        Api.productionPlan.save(plan).then(() => {
        // this.$router.push({'name': 'OrderPlan'})
          let info = {
            collectorID: this.currentCollector.id,
            orderProductID: this.currentOrder.id,
            collectorName: this.currentCollector.name,
            orderNo: this.currentOrder.orderNo,
            productNo: this.currentOrder.productNo,
            planIndex: this.planIndex,
            row: this.row,
            productName: this.currentOrder.name
          }
          this.totalPlanDatas.push(info)
          // this.planDatas.push(info)
        })
        this.Steps = '1'
        this.planDatas = this.totalPlanDatas
        this.Radioselection = 0
        // console.log(this.currentOrder, this.planDatas)
      } else {
        const title = this.$t('plan.Production.error')
        const content = this.$t('plan.Production.error_message')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
    },
    remove (index) {
      if (confirm(this.$t('plan.Production.delete_message'))) {
        let id = this.planDatas[index].id
        Api.productionPlan.delete(id).then(() => {
          this.planDatas.splice(index, 1)
          for (let i = 0; i < this.totalPlanDatas.length; i++) {
            if (this.totalPlanDatas[i].id === id) {
              this.totalPlanDatas.splice(i, 1)
            }
          }
        })
      }
    },
    TabRest () {
      this.planDatas = this.totalPlanDatas
      this.Radioselection = 0
      this.Steps = '1'
    },
    productionStop (index, ID) {
      if (confirm(this.$t('plan.Collector.delete_message'))) {
        let id = this.planDatas[index].id
        Api.productionPlan.close(ID).then(() => {
          this.planDatas.splice(index, 1)
          for (let i = 0; i < this.totalPlanDatas.length; i++) {
            if (this.totalPlanDatas[i].id === id) {
              this.totalPlanDatas.splice(i, 1)
            }
          }
        })
      }
    },
    orderSelect (current, old) {
      let pds = []
      if (current.valid === 0) {
        alert(this.$t('plan.Production.message'))
      } else {
        this.currentOrder = current
        for (let i = 0; i < this.totalPlanDatas.length; i++) {
          if (current.id === this.totalPlanDatas[i].orderProductID) {
            pds.push(this.totalPlanDatas[i])
          }
        }
        this.Steps = '2'
        this.planDatas = pds
      }
    },
    collectorSelect (current, old) {
      this.check = false
      this.currentCollector = current
      let pds = []
      for (let i = 0; i < this.totalPlanDatas.length; i++) {
        if (current.id === this.totalPlanDatas[i].collectorID) {
          pds.push(this.totalPlanDatas[i])
          if (this.totalPlanDatas[i].CPValid === 1) {
            this.check = true
          }
        }
      }
      this.Steps = '3'
      this.planDatas = pds
    },
    planReset () {
      this.planDatas = this.totalPlanDatas
      this.Steps = '1'
    },
    planSearch () {
      let temp1 = []
      let temp2 = []
      if (this.search1 !== '') {
        for (let i = 0; i < this.planDatas.length; i++) {
          if (this.planDatas[i].collectorName.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
            temp1.push(this.planDatas[i])
          }
        }
      } else {
        temp1 = this.planDatas
      }
      if (this.search2 !== '') {
        for (let i = 0; i < temp1.length; i++) {
          if (temp1[i].orderNo.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
            temp2.push(temp1[i])
          }
        }
      } else {
        temp2 = temp1
      }
      this.planDatas = temp2
      // this.Steps = '1'
    },
    handleSearch (tp) {
      if (tp === 1) {
        this.orderDatas = []
        this.temp1 = []
        if (this.Valid === '1') {
          for (let i = 0; i < this.totalOrderDatas.length; i++) {
            let p = this.totalOrderDatas[i]
            for (let j = 0; j < p.orderProducts.length; j++) {
              if (p.orderProducts[j].PPValid === 0 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
                this.temp1.push(p)
                break
              }
            }
          }
        } else if (this.Valid === '2') {
          for (let i = 0; i < this.totalOrderDatas.length; i++) {
            let p = this.totalOrderDatas[i]
            for (let j = 0; j < p.orderProducts.length; j++) {
              if (p.orderProducts[j].PPValid === 1 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
                this.temp1.push(p)
                break
              }
            }
          }
        } else if (this.Valid === '3') {
          for (let i = 0; i < this.totalOrderDatas.length; i++) {
            let p = this.totalOrderDatas[i]
            for (let j = 0; j < p.orderProducts.length; j++) {
              if (p.orderProducts[j].PPValid === 1 && p.orderProducts[j].CPValid === 1 && p.orderProducts[j].Closedtime === '') {
                this.temp1.push(p)
                break
              }
            }
          }
        } else {
          this.temp1 = this.totalOrderDatas
        }
        for (let i = 0; i < this.temp1.length; i++) {
          let o = this.temp1[i]
          if (o.orderNo.toLowerCase().indexOf(this.searchOrder.toLowerCase()) !== -1) {
            this.orderDatas.push(o)
          }
        }
      } else if (tp === 2) {
        this.collectorDatas = []
        for (let i = 0; i < this.totalCollectorDatas.length; i++) {
          let c = this.totalCollectorDatas[i]
          if (c.name.toLowerCase().indexOf(this.searchCollector.toLowerCase()) !== -1 || c.deviceNo.toLowerCase().indexOf(this.searchCollector.toLowerCase()) !== -1) {
            this.collectorDatas.push(c)
          }
        }
      }
    },
    handleReset (tp) {
      if (tp === 1) {
        this.orderDatas = this.totalOrderDatas
      } else if (tp === 2) {
        this.collectorDatas = this.totalCollectorDatas
      }
    },
    ProductionSelect (s) {
      console.log('sss:', s)
      if (s === 1) {
        this.Radioselection = 1
      } else if (s === 2) {
        this.Radioselection = 2
      } else if (s === 3) {
        this.Radioselection = 3
      }
    }
  },
  mounted () {
    Api.order.list().then(res => {
      let d = []
      this.totalOrderDatas = res.orderInfos
      this.orderDatas = this.totalOrderDatas
      for (let i = 0; i < this.orderDatas.length; i++) {
        if (this.orderDatas[i].Ordervalid === 1) {
          for (let j = 0; j < this.orderDatas[i].orderProducts.length; j++) {
            if (this.orderDatas[i].orderProducts[j].valid === 0) {
              this.orderDatas[i].orderProducts[j].status1 = 'success'
              this.orderDatas[i].orderProducts[j].status2 = this.$t('plan.Production.Case_closed')
            } else if (this.orderDatas[i].orderProducts[j].PPValid === 1 && this.orderDatas[i].orderProducts[j].CPValid === 1) {
              this.orderDatas[i].orderProducts[j].status1 = 'primary'
              this.orderDatas[i].orderProducts[j].status2 = this.$t('plan.Production.Producting')
            } else if (this.orderDatas[i].orderProducts[j].PPValid === 1) {
              this.orderDatas[i].orderProducts[j].status1 = 'warning'
              this.orderDatas[i].orderProducts[j].status2 = this.$t('plan.Production.Not_production')
            } else {
              this.orderDatas[i].orderProducts[j].status1 = 'error'
              this.orderDatas[i].orderProducts[j].status2 = this.$t('plan.Production.No_scheduling')
            }
          }
          d.push(this.orderDatas[i])
        }
      }
      this.totalOrderDatas = d
      this.orderDatas = d
    })
    Api.collector.list().then(res => {
      this.totalCollectorDatas = res.collectors
      this.collectorDatas = this.totalCollectorDatas
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
    Api.productionPlan.list().then(res => {
      if (res.productionPlanInfos !== undefined) {
        this.totalPlanDatas = res.productionPlanInfos
        this.planDatas = this.totalPlanDatas
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    // Api.product.list().then(res => {
    //   next(vm => { vm.datas = res.products })
    // })
    next()
  }
}
</script>
<style scoped>
.ivu-input[disabled], fieldset[disabled] .ivu-input {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #0000CD;
}
.plan-page {
  padding: 10px;
}
/* .plan-row .ivu-col {
  padding: 0 2px;
} */
.order-card {
  margin-top: 10px;
}
.collector-table {
  margin-top: 10px;
}
.edit-card {
  margin-bottom: 10px;
}
.edit-form {
  padding: 20px 0px;
  text-align: left;
}
.edit-form .info {
  width: 33.33333%
}
/* .info {
  width: 70%;
} */
hr {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin: 1.5rem 0;
}
.title {
  text-align: center;
  margin-bottom: 10px;
}
.plan-btn {
  width: 100%;
}
.custom-tabs{
  overflow-y: auto;
}
</style>





// WEBPACK FOOTER //
// production.vue?04f3939d